import React, { Component } from "react";
import { useParams } from "react-router-dom";
import _ from "lodash";
import "./addes.css";
import LoaderCon from "../../Common/loader/containers/loader_cont";
import Snackbar1 from "../../Common/snackbar/components/snackbar";


function withParams(Component) {
  return (props) => <Component {...props} params={useParams()} />;
}

class Employee extends Component {
  constructor(props) {
    super(props);
    this.state = {
      view: false,
      add: false,
      edit: false,
      reject: false,
      selectedEmployee: null,
      searchInput: "",
      page: 0,
      rowsPerPage: 10,
      image: null,
      candidates_id: 0,
      selectedData: null,
      addes_id: "",
      startDate: "",
      endDate: "",
      selectedStatus: "",
      media: null,
      mediaType: "",
    };
    this.debouncedSearch = _.debounce(this.handleSearch, 300);
  }

  handleChangePage = (event, newPage) => {
    this.setState({ page: newPage }, () => {
      this.props.viewAlladdes(
        this.props.login.token,
        this.props.login.user_id,
        this.state.searchInput,
        newPage,
        this.state.rowsPerPage,
        this.state.startDate,
        this.state.endDate,
        this.state.selectedStatus
      );
    });
  };

  handleChangeRowsPerPage = (event) => {
    this.setState(
      {
        rowsPerPage: parseInt(event.target.value, 10),
        page: 0,
      },
      () => {
        this.props.viewAlladdes(
          this.props.login.token,
          this.props.login.user_id,
          this.state.searchInput,
          0,
          this.state.rowsPerPage,
          this.state.startDate,
          this.state.endDate,
          this.state.selectedStatus
        );
      }
    );
  };

  toggleStatus = async (item) => {
    const newStatus = item.status === "Active" ? "Inactive" : "Active";
    this.props.updateStatus(
      this.props.login.token,
      this.props.login.user_id,
      item._id,
      newStatus,
      this.state.page,
      this.state.rowsPerPage
    );
  };

  handleSearch = () => {
    this.props.viewAlladdes(
      this.props.login.token,
      this.props.login.user_id,
      this.state.searchInput,
      this.state.page,
      this.state.rowsPerPage,
      this.state.startDate,
      this.state.endDate,
      this.state.selectedStatus
    );
  };

  handleSearchChange = (event) => {
    const searchInput = event.target.value;
    this.setState({ searchInput }, () => {
      this.debouncedSearch();
    });
  };

  handleDialogOpen = (employee) => {
    this.setState({ selectedEmployee: employee, view: true });
  };

  handleDialogClose = () => {
    this.setState({ view: false, selectedEmployee: null });
  };

  componentDidMount() {
    this.props.viewAlladdes(
      this.props.login.token,
      this.props.login.user_id,
      this.state.searchInput,
      this.state.page,
      this.state.rowsPerPage,
      this.state.startDate,
      this.state.endDate,
      this.state.selectedStatus
    );
  }

  handleStartDateChange = (event) => {
    this.setState({ startDate: event.target.value });
    this.props.viewAlladdes(
      this.props.login.token,
      this.props.login.user_id,
      this.state.searchInput,
      this.state.page,
      this.state.rowsPerPage,
      event.target.value,
      this.state.endDate,
      this.state.selectedStatus
    )
  };

  handleEndDateChange = (event) => {
    this.setState({ endDate: event.target.value });
    this.props.viewAlladdes(
      this.props.login.token,
      this.props.login.user_id,
      this.state.searchInput,
      this.state.page,
      this.state.rowsPerPage,
      this.state.startDate,
      event.target.value,
      this.state.selectedStatus
    );

  };

  handleStatusChange = (event) => {
    this.setState({ selectedStatus: event.target.value });
    this.props.viewAlladdes(
      this.props.login.token,
      this.props.login.user_id,
      this.state.searchInput,
      this.state.page,
      this.state.rowsPerPage,
      this.state.startDate,
      this.state.endDate,
      event.target.value
    );

  };
  handleMediaChange = (e, type) => {
    const file = e.target.files[0];
    this.setState({
      media: file,
      mediaType: type,
    });
  };

  render() {
    const {
      selectedEmployee,
      view,
      add,
      page,
      rowsPerPage,
    } = this.state;

    const allAddesLength = this.props.client?.all_addeslength || 0;

    return (
      <div style={{
        padding: "20px",
        marginTop: "50px",
        fontFamily: "KIAbodyLatinbasic_Regular, Arial, sans-serif"
      }}>
        {/* Header Section: Create Advertisement Button */}
        <div style={{
          display: "flex",
          justifyContent: "flex-end",
          marginBottom: "20px"
        }}>
          <button
            onClick={() => this.setState({ add: true })}
            style={{
              padding: "10px 20px",
              backgroundColor: "#1976d2",
              color: "white",
              border: "none",
              borderRadius: "4px",
              cursor: "pointer",
              fontSize: "14px",
              fontWeight: "500"
            }}
          >
            Create Advertisement
          </button>
        </div>

        {/* Filter and Pagination Section */}
        <div style={{
          marginBottom: "20px",
          background: "white",
          padding: "16px",
          borderRadius: "8px",
          boxShadow: "0 2px 4px rgba(0,0,0,0.1)"
        }}>
          <div style={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))",
            gap: "12px",
            alignItems: "center"
          }}>
            {/* Start Date Filter */}
            <div>
              <label style={{
                display: "block",
                marginBottom: "4px",
                fontSize: "14px",
                color: "#666"
              }}>
                Start Date
              </label>
              <input
                type="date"
                onChange={this.handleStartDateChange}
                style={{
                  padding: "8px",
                  border: "1px solid #ddd",
                  borderRadius: "4px",
                  width: "100%",
                  fontSize: "14px",
                  boxSizing: "border-box"
                }}
              />
            </div>

            {/* End Date Filter */}
            <div>
              <label style={{
                display: "block",
                marginBottom: "4px",
                fontSize: "14px",
                color: "#666"
              }}>
                End Date
              </label>
              <input
                type="date"
                onChange={this.handleEndDateChange}
                style={{
                  padding: "8px",
                  border: "1px solid #ddd",
                  borderRadius: "4px",
                  width: "100%",
                  fontSize: "14px",
                  boxSizing: "border-box"
                }}
              />
            </div>

            {/* Status Filter */}
            <div>
              <label style={{
                display: "block",
                marginBottom: "4px",
                fontSize: "14px",
                color: "#666"
              }}>
                Filter by Status
              </label>
              <select
                onChange={this.handleStatusChange}
                style={{
                  padding: "8px",
                  border: "1px solid #ddd",
                  borderRadius: "4px",
                  width: "100%",
                  fontSize: "14px",
                  background: "white"
                }}
                defaultValue=""
              >
                <option value="">All</option>
                <option value="Active">Active</option>
                <option value="Inactive">Inactive</option>
              </select>
            </div>

            {/* Pagination Section */}
            <div style={{
              display: "flex",
              justifyContent: "flex-end",
              alignItems: "center",
              gap: "12px",
              flexWrap: "wrap"
            }}>
              <span style={{ fontSize: "14px", color: "#666" }}>
                {allAddesLength > 0 ? `1-${Math.min(rowsPerPage, allAddesLength)} of ${allAddesLength}` : '0 items'}
              </span>
              <select
                value={rowsPerPage}
                onChange={this.handleChangeRowsPerPage}
                style={{
                  padding: "4px 8px",
                  border: "1px solid #ddd",
                  borderRadius: "4px",
                  fontSize: "14px"
                }}
              >
                <option value={5}>5</option>
                <option value={10}>10</option>
                <option value={25}>25</option>
                <option value={50}>50</option>
                <option value={100}>100</option>
                <option value={allAddesLength}>All</option>
              </select>
              <div style={{ display: "flex", gap: "4px" }}>
                <button
                  onClick={() => this.handleChangePage(null, page - 1)}
                  disabled={page === 0}
                  style={{
                    padding: "4px 8px",
                    border: "1px solid #ddd",
                    background: "white",
                    borderRadius: "4px",
                    cursor: page === 0 ? "not-allowed" : "pointer",
                    opacity: page === 0 ? 0.5 : 1
                  }}
                >
                  ‹
                </button>
                <button
                  onClick={() => this.handleChangePage(null, page + 1)}
                  disabled={(page + 1) * rowsPerPage >= allAddesLength}
                  style={{
                    padding: "4px 8px",
                    border: "1px solid #ddd",
                    background: "white",
                    borderRadius: "4px",
                    cursor: (page + 1) * rowsPerPage >= allAddesLength ? "not-allowed" : "pointer",
                    opacity: (page + 1) * rowsPerPage >= allAddesLength ? 0.5 : 1
                  }}
                >
                  ›
                </button>
              </div>
            </div>
          </div>
        </div>

        {/* Advertisement Table */}
        <div style={{
          background: "white",
          borderRadius: "8px",
          boxShadow: "0 4px 10px rgba(0, 0, 0, 0.1)",
          overflow: "hidden"
        }}>
          <div style={{ overflowX: "auto" }}>
            <table style={{
              width: "100%",
              borderCollapse: "collapse",
              fontSize: "14px",
              minWidth: "600px"
            }}>
              <thead>
                <tr style={{ backgroundColor: "#f5f5f5" }}>
                  {["Sl No", "Image", "Date", "Time", "Status", "Action"].map(
                    (header, index) => (
                      <th key={index} style={{
                        padding: "12px 8px",
                        textAlign: "center",
                        fontWeight: "bold",
                        borderBottom: "2px solid #e0e0e0"
                      }}>
                        {header}
                      </th>
                    )
                  )}
                </tr>
              </thead>
              <tbody>
                {Array.isArray(this.props.client.all_addes) &&
                  this.props.client.all_addes?.map((item, index) => {
                    const createdAt = new Date(item.createdAt);
                    const date = createdAt.toLocaleDateString();
                    const time = createdAt.toLocaleTimeString([], {
                      hour: "2-digit",
                      minute: "2-digit",
                    });

                    return (
                      <tr
                        key={index}
                        style={{
                          backgroundColor: index % 2 === 0 ? "#fafafa" : "#ffffff",
                          borderBottom: "1px solid #e0e0e0"
                        }}
                      >
                        <td style={{ padding: "12px 8px", textAlign: "center" }}>
                          {index + 1}
                        </td>
                        <td style={{ padding: "12px 8px", textAlign: "center" }}>
                          {item.mediaType === "image" ? (
                            <img
                              src={item.image}
                              alt="Advertisement"
                              style={{
                                width: "80px",
                                height: "80px",
                                border: "1px solid #ddd",
                                borderRadius: "4px",
                                objectFit: "cover"
                              }}
                            />
                          ) : (
                            <video
                              src={item.image}
                              controls
                              style={{
                                width: "80px",
                                height: "80px",
                                border: "1px solid #ddd",
                                borderRadius: "4px",
                                objectFit: "cover"
                              }}
                            />
                          )}
                        </td>

                        <td style={{ padding: "12px 8px", textAlign: "center" }}>
                          {date}
                        </td>
                        <td style={{ padding: "12px 8px", textAlign: "center" }}>
                          {time}
                        </td>
                        <td style={{ padding: "12px 8px", textAlign: "center" }}>
                          <div className="toggle-switch">
                            <input
                              type="checkbox"
                              checked={item.status === "Active"}
                              onChange={() => this.toggleStatus(item)}
                              style={{ display: "none" }}
                            />
                            <span
                              className="slider round"
                              onClick={() => this.toggleStatus(item)}
                              style={{
                                cursor: "pointer",
                                display: "inline-block"
                              }}
                            ></span>
                          </div>
                        </td>
                        <td style={{ padding: "12px 8px", textAlign: "center" }}>
                          <div style={{ display: "flex", justifyContent: "center", gap: "8px" }}>
                            <button
                              onClick={() => this.handleDialogOpen(item)}
                              style={{
                                background: "none",
                                border: "none",
                                cursor: "pointer",
                                padding: "4px",
                                borderRadius: "4px",
                                fontSize: "16px"
                              }}
                              title="View Image"
                            >
                              👁️
                            </button>
                            <button
                              onClick={() =>
                                this.setState({
                                  selectedData: item,
                                  edit: true,
                                })
                              }
                              style={{
                                background: "none",
                                border: "none",
                                cursor: "pointer",
                                padding: "4px",
                                borderRadius: "4px",
                                fontSize: "16px"
                              }}
                              title="Edit"
                            >
                              ✏️
                            </button>
                            <button
                              onClick={() =>
                                this.setState({
                                  addes_id: item._id,
                                  reject: true,
                                })
                              }
                              style={{
                                background: "none",
                                border: "none",
                                cursor: "pointer",
                                padding: "4px",
                                borderRadius: "4px",
                                fontSize: "16px"
                              }}
                              title="Delete"
                            >
                              🗑️
                            </button>
                          </div>
                        </td>
                      </tr>
                    );
                  })}
              </tbody>
            </table>
          </div>
        </div>

        {/* View Dialog */}
        {selectedEmployee && view && (
          <div style={{
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 1000
          }}>
            <div style={{
              background: "white",
              borderRadius: "8px",
              padding: 0,
              minWidth: "400px",
              maxWidth: "500px",
              width: "90%",
              boxShadow: "0 4px 20px rgba(0,0,0,0.15)"
            }}>
              <div style={{ padding: "16px 24px", borderBottom: "1px solid #eee" }}>
                <h3 style={{ margin: 0, fontSize: "18px", fontWeight: "600" }}>Image Details</h3>
              </div>
              <div style={{ padding: "20px 24px" }}>
                <div style={{ display: "flex", justifyContent: "center" }}>
                  {selectedEmployee.mediaType === "image" ? (
                    <img
                      src={selectedEmployee.image}
                      alt="Employee"
                      style={{ width: "100%", height: "auto", borderRadius: "4px" }}
                    />
                  ) : (
                    <video
                      src={selectedEmployee.image}
                      controls
                      style={{ width: "100%", height: "auto", borderRadius: "4px" }}
                    />
                  )}
                </div>
              </div>
              <div style={{
                padding: "16px 24px",
                borderTop: "1px solid #eee",
                display: "flex",
                justifyContent: "flex-end"
              }}>
                <button
                  onClick={this.handleDialogClose}
                  style={{
                    padding: "8px 16px",
                    background: "#1976d2",
                    color: "white",
                    border: "none",
                    borderRadius: "4px",
                    cursor: "pointer",
                    fontSize: "14px"
                  }}
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        )}

        {/* Add Dialog */}
        {add && (
          // <div
          //   style={{
          //     position: "fixed",
          //     top: 0,
          //     left: 0,
          //     right: 0,
          //     bottom: 0,
          //     backgroundColor: "rgba(0, 0, 0, 0.5)",
          //     display: "flex",
          //     justifyContent: "center",
          //     alignItems: "center",
          //     zIndex: 1000,
          //   }}
          // >
          //   <div
          //     style={{
          //       background: "white",
          //       borderRadius: "8px",
          //       padding: 0,
          //       minWidth: "400px",
          //       maxWidth: "500px",
          //       width: "90%",
          //     }}
          //   >
          //     <div
          //       style={{
          //         padding: "16px 24px",
          //         borderBottom: "1px solid #eee",
          //       }}
          //     >
          //       <h3 style={{ margin: 0, fontSize: "18px", fontWeight: "600" }}>
          //         Upload Media
          //       </h3>
          //     </div>

          //     <div style={{ padding: "20px 24px" }}>
          //       <div
          //         style={{
          //           display: "flex",
          //           flexDirection: "column",
          //           gap: "16px",
          //         }}
          //       >
          //         {/* Upload Image */}
          //         <div>
          //           <input
          //             id="upload-image"
          //             type="file"
          //             accept="image/*"
          //             style={{ display: "none" }}
          //             onChange={(e) => this.handleMediaChange(e, "image")}
          //           />

          //           <button
          //             type="button"
          //             onClick={() => document.getElementById("upload-image").click()}
          //             style={{
          //               padding: "10px 16px",
          //               background: "#1976d2",
          //               color: "white",
          //               border: "none",
          //               borderRadius: "4px",
          //               cursor: "pointer",
          //               width: "100%",
          //               fontSize: "14px",
          //             }}
          //           >
          //             Upload Image
          //           </button>
          //         </div>

          //         {/* Upload Video */}
          //         <div>
          //           <input
          //             id="upload-video"
          //             type="file"
          //             accept="video/*"
          //             style={{ display: "none" }}
          //             onChange={(e) => this.handleMediaChange(e, "video")}
          //           />

          //           <button
          //             type="button"
          //             onClick={() => document.getElementById("upload-video").click()}
          //             style={{
          //               padding: "10px 16px",
          //               background: "#6c757d",
          //               color: "white",
          //               border: "none",
          //               borderRadius: "4px",
          //               cursor: "pointer",
          //               width: "100%",
          //               fontSize: "14px",
          //             }}
          //           >
          //             Upload Video
          //           </button>
          //         </div>

          //         {/* Preview */}
          //         {this.state.media && (
          //           <div style={{ textAlign: "center" }}>
          //             <div
          //               style={{
          //                 marginBottom: "8px",
          //                 fontSize: "14px",
          //                 fontWeight: "500",
          //               }}
          //             >
          //               Selected {this.state.mediaType}: {this.state.media.name}
          //             </div>

          //             {this.state.mediaType === "image" ? (
          //               <img
          //                 src={URL.createObjectURL(this.state.media)}
          //                 alt="Preview"
          //                 style={{
          //                   maxWidth: "100%",
          //                   height: "auto",
          //                   borderRadius: "8px",
          //                   boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
          //                   maxHeight: "300px",
          //                 }}
          //               />
          //             ) : (
          //               <video
          //                 controls
          //                 style={{
          //                   maxWidth: "100%",
          //                   height: "auto",
          //                   borderRadius: "8px",
          //                   boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
          //                   maxHeight: "300px",
          //                 }}
          //               >
          //                 <source src={URL.createObjectURL(this.state.media)} />
          //               </video>
          //             )}
          //           </div>
          //         )}
          //       </div>
          //     </div>

          //     <div
          //       style={{
          //         padding: "16px 24px",
          //         borderTop: "1px solid #eee",
          //         display: "flex",
          //         justifyContent: "flex-end",
          //         gap: "12px",
          //       }}
          //     >
          //       <button
          //         onClick={() => {
          //           this.props.uploadImaes(
          //             this.props.login.token,
          //             this.props.login.user_id,
          //             this.state.media,
          //             this.state.mediaType,
          //             this.state.page,
          //             this.state.rowsPerPage
          //           );
          //           this.setState({ add: false, media: null, mediaType: "" });
          //         }}
          //         style={{
          //           padding: "8px 16px",
          //           background: "#1976d2",
          //           color: "white",
          //           border: "none",
          //           borderRadius: "4px",
          //           cursor: "pointer",
          //           fontSize: "14px",
          //         }}
          //       >
          //         Add
          //       </button>

          //       <button
          //         onClick={() =>
          //           this.setState({
          //             add: false,
          //             media: null,
          //             mediaType: "",
          //           })
          //         }
          //         style={{
          //           padding: "8px 16px",
          //           background: "#6c757d",
          //           color: "white",
          //           border: "none",
          //           borderRadius: "4px",
          //           cursor: "pointer",
          //           fontSize: "14px",
          //         }}
          //       >
          //         Close
          //       </button>
          //     </div>
          //   </div>
          // </div>
          
  <div
    style={{
      position: "fixed",
      inset: 0,
      background: "rgba(0,0,0,0.6)",
      backdropFilter: "blur(4px)",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      zIndex: 1000,
    }}
  >
    <div
      style={{
        background: "#ffffff",
        borderRadius: "16px",
        width: "95%",
        maxWidth: "520px",
        padding: "0",
        overflow: "hidden",
        animation: "fadeIn 0.3s ease-in-out",
        boxShadow: "0 20px 40px rgba(0,0,0,0.2)",
      }}
    >
      {/* Header */}
      <div
        style={{
          padding: "20px",
          background: "linear-gradient(135deg, #1976d2, #42a5f5)",
          color: "white",
          textAlign: "center",
        }}
      >
        <h2 style={{ margin: 0, fontWeight: "600" }}>
          Upload Advertisement
        </h2>
      </div>

      {/* Body */}
      <div style={{ padding: "30px" }}>
        <div
          style={{
            display: "flex",
            gap: "20px",
            justifyContent: "center",
            flexWrap: "wrap",
          }}
        >
          {/* Image Upload */}
          <div style={{ textAlign: "center" }}>
            <input
              id="upload-image"
              type="file"
              accept="image/*"
              style={{ display: "none" }}
              onChange={(e) => this.handleMediaChange(e, "image")}
            />
            <div
              onClick={() =>
                document.getElementById("upload-image").click()
              }
              style={{
                border: "2px dashed #1976d2",
                padding: "25px",
                borderRadius: "12px",
                cursor: "pointer",
                width: "180px",
                transition: "0.3s",
              }}
            >
              📷
              <p style={{ margin: "10px 0 0", fontSize: "14px" }}>
                Upload Image
              </p>
            </div>
          </div>

          {/* Video Upload */}
          <div style={{ textAlign: "center" }}>
            <input
              id="upload-video"
              type="file"
              accept="video/*"
              style={{ display: "none" }}
              onChange={(e) => this.handleMediaChange(e, "video")}
            />
            <div
              onClick={() =>
                document.getElementById("upload-video").click()
              }
              style={{
                border: "2px dashed #6c757d",
                padding: "25px",
                borderRadius: "12px",
                cursor: "pointer",
                width: "180px",
                transition: "0.3s",
              }}
            >
              🎥
              <p style={{ margin: "10px 0 0", fontSize: "14px" }}>
                Upload Video
              </p>
            </div>
          </div>
        </div>

        {/* Preview */}
        {this.state.media && (
          <div style={{ marginTop: "25px", textAlign: "center" }}>
            <p style={{ fontWeight: "500", marginBottom: "10px" }}>
              Preview:
            </p>

            {this.state.mediaType === "image" ? (
              <img
                src={URL.createObjectURL(this.state.media)}
                alt="Preview"
                style={{
                  maxWidth: "100%",
                  maxHeight: "250px",
                  borderRadius: "12px",
                  boxShadow: "0 10px 20px rgba(0,0,0,0.15)",
                }}
              />
            ) : (
              <video
                controls
                style={{
                  maxWidth: "100%",
                  maxHeight: "250px",
                  borderRadius: "12px",
                  boxShadow: "0 10px 20px rgba(0,0,0,0.15)",
                }}
              >
                <source
                  src={URL.createObjectURL(this.state.media)}
                />
              </video>
            )}
          </div>
        )}
      </div>

      {/* Footer */}
      <div
        style={{
          padding: "20px",
          display: "flex",
          justifyContent: "flex-end",
          gap: "10px",
          borderTop: "1px solid #eee",
        }}
      >
        <button
          onClick={() => {
            this.props.uploadImaes(
              this.props.login.token,
              this.props.login.user_id,
              this.state.media,
              this.state.mediaType,
              this.state.page,
              this.state.rowsPerPage
            );
            this.setState({ add: false, media: null, mediaType: "" });
          }}
          style={{
            padding: "10px 18px",
            background: "#1976d2",
            color: "white",
            border: "none",
            borderRadius: "8px",
            cursor: "pointer",
            fontWeight: "500",
          }}
        >
          Upload
        </button>

        <button
          onClick={() =>
            this.setState({
              add: false,
              media: null,
              mediaType: "",
            })
          }
          style={{
            padding: "10px 18px",
            background: "#6c757d",
            color: "white",
            border: "none",
            borderRadius: "8px",
            cursor: "pointer",
            fontWeight: "500",
          }}
        >
          Cancel
        </button>
      </div>
    </div>
  </div>

        )}


        {/* Edit Dialog */}
        {this.state.edit && (
         
  <div
    style={{
      position: "fixed",
      inset: 0,
      background: "rgba(0,0,0,0.6)",
      backdropFilter: "blur(4px)",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      zIndex: 1000,
    }}
  >
    <div
      style={{
        background: "#ffffff",
        borderRadius: "16px",
        width: "95%",
        maxWidth: "520px",
        overflow: "hidden",
        boxShadow: "0 20px 40px rgba(0,0,0,0.2)",
      }}
    >
      {/* Header */}
      <div
        style={{
          padding: "20px",
          background: "linear-gradient(135deg, #1976d2, #42a5f5)",
          color: "white",
          textAlign: "center",
        }}
      >
        <h2 style={{ margin: 0, fontWeight: "600" }}>
          Edit Advertisement
        </h2>
      </div>

      {/* Body */}
      <div style={{ padding: "30px" }}>
        <div
          style={{
            display: "flex",
            gap: "20px",
            justifyContent: "center",
            flexWrap: "wrap",
          }}
        >
          {/* Upload Image */}
          <div style={{ textAlign: "center" }}>
            <input
              id="edit-upload-image"
              type="file"
              accept="image/*"
              style={{ display: "none" }}
              onChange={(e) => this.handleMediaChange(e, "image")}
            />
            <div
              onClick={() =>
                document.getElementById("edit-upload-image").click()
              }
              style={{
                border: "2px dashed #1976d2",
                padding: "25px",
                borderRadius: "12px",
                cursor: "pointer",
                width: "180px",
              }}
            >
              📷
              <p style={{ margin: "10px 0 0", fontSize: "14px" }}>
                Change Image
              </p>
            </div>
          </div>

          {/* Upload Video */}
          <div style={{ textAlign: "center" }}>
            <input
              id="edit-upload-video"
              type="file"
              accept="video/*"
              style={{ display: "none" }}
              onChange={(e) => this.handleMediaChange(e, "video")}
            />
            <div
              onClick={() =>
                document.getElementById("edit-upload-video").click()
              }
              style={{
                border: "2px dashed #6c757d",
                padding: "25px",
                borderRadius: "12px",
                cursor: "pointer",
                width: "180px",
              }}
            >
              🎥
              <p style={{ margin: "10px 0 0", fontSize: "14px" }}>
                Change Video
              </p>
            </div>
          </div>
        </div>

        {/* Preview */}
        {this.state.media && (
          <div style={{ marginTop: "25px", textAlign: "center" }}>
            <p style={{ fontWeight: "500", marginBottom: "10px" }}>
              Preview:
            </p>

            {this.state.mediaType === "image" ? (
              <img
                src={URL.createObjectURL(this.state.media)}
                alt="Preview"
                style={{
                  maxWidth: "100%",
                  maxHeight: "250px",
                  borderRadius: "12px",
                  boxShadow: "0 10px 20px rgba(0,0,0,0.15)",
                }}
              />
            ) : (
              <video
                controls
                style={{
                  maxWidth: "100%",
                  maxHeight: "250px",
                  borderRadius: "12px",
                  boxShadow: "0 10px 20px rgba(0,0,0,0.15)",
                }}
              >
                <source
                  src={URL.createObjectURL(this.state.media)}
                />
              </video>
            )}
          </div>
        )}
      </div>

      {/* Footer */}
      <div
        style={{
          padding: "20px",
          display: "flex",
          justifyContent: "flex-end",
          gap: "10px",
          borderTop: "1px solid #eee",
        }}
      >
        <button
          onClick={() => {
            if (this.state.media) {
              this.props.uploadupdatesImages(
                this.props.login.token,
                this.props.login.user_id,
                this.state.selectedData._id,
                this.state.media,
                this.state.mediaType,
                this.state.page,
                this.state.rowsPerPage
              );
            }
            this.setState({ edit: false, media: null, mediaType: "" });
          }}
          style={{
            padding: "10px 18px",
            background: "#1976d2",
            color: "white",
            border: "none",
            borderRadius: "8px",
            cursor: "pointer",
            fontWeight: "500",
          }}
        >
          Save Changes
        </button>

        <button
          onClick={() =>
            this.setState({ edit: false, media: null, mediaType: "" })
          }
          style={{
            padding: "10px 18px",
            background: "#6c757d",
            color: "white",
            border: "none",
            borderRadius: "8px",
            cursor: "pointer",
            fontWeight: "500",
          }}
        >
          Cancel
        </button>
      </div>
    </div>
  </div>

          // <div
          //   style={{
          //     position: "fixed",
          //     top: 0,
          //     left: 0,
          //     right: 0,
          //     bottom: 0,
          //     backgroundColor: "rgba(0, 0, 0, 0.5)",
          //     display: "flex",
          //     justifyContent: "center",
          //     alignItems: "center",
          //     zIndex: 1000,
          //   }}
          // >
          //   <div
          //     style={{
          //       background: "white",
          //       borderRadius: "8px",
          //       padding: 0,
          //       minWidth: "400px",
          //       maxWidth: "500px",
          //       width: "90%",
          //     }}
          //   >
          //     <div
          //       style={{
          //         padding: "16px 24px",
          //         borderBottom: "1px solid #eee",
          //       }}
          //     >
          //       <h3 style={{ margin: 0, fontSize: "18px", fontWeight: "600" }}>
          //         Upload Media (Edit)
          //       </h3>
          //     </div>

          //     <div style={{ padding: "20px 24px" }}>
          //       <div
          //         style={{
          //           display: "flex",
          //           flexDirection: "column",
          //           gap: "16px",
          //         }}
          //       >
          //         {/* Upload Image */}
          //         <div>
          //           <input
          //             id="edit-upload-image"
          //             type="file"
          //             accept="image/*"
          //             style={{ display: "none" }}
          //             onChange={(e) => this.handleMediaChange(e, "image")}
          //           />

          //           <button
          //             type="button"
          //             onClick={() =>
          //               document.getElementById("edit-upload-image").click()
          //             }
          //             style={{
          //               padding: "10px 16px",
          //               background: "#1976d2",
          //               color: "white",
          //               border: "none",
          //               borderRadius: "4px",
          //               cursor: "pointer",
          //               width: "100%",
          //               fontSize: "14px",
          //             }}
          //           >
          //             Upload Image
          //           </button>
          //         </div>

          //         {/* Upload Video */}
          //         <div>
          //           <input
          //             id="edit-upload-video"
          //             type="file"
          //             accept="video/*"
          //             style={{ display: "none" }}
          //             onChange={(e) => this.handleMediaChange(e, "video")}
          //           />

          //           <button
          //             type="button"
          //             onClick={() =>
          //               document.getElementById("edit-upload-video").click()
          //             }
          //             style={{
          //               padding: "10px 16px",
          //               background: "#6c757d",
          //               color: "white",
          //               border: "none",
          //               borderRadius: "4px",
          //               cursor: "pointer",
          //               width: "100%",
          //               fontSize: "14px",
          //             }}
          //           >
          //             Upload Video
          //           </button>
          //         </div>

          //         {/* Preview */}
          //         {this.state.media && (
          //           <div style={{ textAlign: "center" }}>
          //             <div
          //               style={{
          //                 marginBottom: "8px",
          //                 fontSize: "14px",
          //                 fontWeight: "500",
          //               }}
          //             >
          //               Selected {this.state.mediaType}: {this.state.media.name}
          //             </div>

          //             {this.state.mediaType === "image" ? (
          //               <img
          //                 src={URL.createObjectURL(this.state.media)}
          //                 alt="Preview"
          //                 style={{
          //                   maxWidth: "100%",
          //                   height: "auto",
          //                   borderRadius: "8px",
          //                   boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
          //                   maxHeight: "300px",
          //                 }}
          //               />
          //             ) : (
          //               <video
          //                 controls
          //                 style={{
          //                   maxWidth: "100%",
          //                   height: "auto",
          //                   borderRadius: "8px",
          //                   boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
          //                   maxHeight: "300px",
          //                 }}
          //               >
          //                 <source src={URL.createObjectURL(this.state.media)} />
          //               </video>
          //             )}
          //           </div>
          //         )}
          //       </div>
          //     </div>

          //     <div
          //       style={{
          //         padding: "16px 24px",
          //         borderTop: "1px solid #eee",
          //         display: "flex",
          //         justifyContent: "flex-end",
          //         gap: "12px",
          //       }}
          //     >
          //       <button
          //         onClick={() => {
          //           if (this.state.media) {
          //             this.props.uploadupdatesImages(
          //               this.props.login.token,
          //               this.props.login.user_id,
          //               this.state.selectedData._id,
          //               this.state.media,
          //               this.state.mediaType,
          //               this.state.page,
          //               this.state.rowsPerPage
          //             );
          //           }
          //           this.setState({ edit: false, media: null, mediaType: "" });
          //         }}
          //         style={{
          //           padding: "8px 16px",
          //           background: "#1976d2",
          //           color: "white",
          //           border: "none",
          //           borderRadius: "4px",
          //           cursor: "pointer",
          //           fontSize: "14px",
          //         }}
          //       >
          //         Save Changes
          //       </button>

          //       <button
          //         onClick={() =>
          //           this.setState({ edit: false, media: null, mediaType: "" })
          //         }
          //         style={{
          //           padding: "8px 16px",
          //           background: "#6c757d",
          //           color: "white",
          //           border: "none",
          //           borderRadius: "4px",
          //           cursor: "pointer",
          //           fontSize: "14px",
          //         }}
          //       >
          //         Cancel
          //       </button>
          //     </div>
          //   </div>
          // </div>
        )}


        {/* Delete Dialog */}
        {this.state.reject && (
          <div style={{
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 1000
          }}>
            <div style={{
              background: "white",
              borderRadius: "8px",
              padding: 0,
              minWidth: "300px",
              maxWidth: "400px",
              width: "90%"
            }}>
              <div style={{ padding: "16px 24px", borderBottom: "1px solid #eee" }}>
                <h3 style={{ margin: 0, fontSize: "18px", fontWeight: "600" }}>Confirm Delete</h3>
              </div>
              <div style={{ padding: "20px 24px" }}>
                <p style={{ margin: 0 }}>
                  Are you sure you want to Delete the Advertisement?
                </p>
              </div>
              <div style={{
                padding: "16px 24px",
                borderTop: "1px solid #eee",
                display: "flex",
                justifyContent: "flex-end",
                gap: "12px"
              }}>
                <button
                  onClick={(e) => {
                    this.props.deleteAddes(
                      this.props.login.token,
                      this.props.login.user_id,
                      this.state.addes_id,
                      this.state.page,
                      this.state.rowsPerPage
                    );
                    this.setState({ reject: false, addes_id: "" });
                  }}
                  style={{
                    padding: "8px 16px",
                    background: "#dc3545",
                    color: "white",
                    border: "none",
                    borderRadius: "4px",
                    cursor: "pointer",
                    fontSize: "14px"
                  }}
                >
                  Yes
                </button>
                <button
                  onClick={() => this.setState({ reject: false })}
                  style={{
                    padding: "8px 16px",
                    background: "#6c757d",
                    color: "white",
                    border: "none",
                    borderRadius: "4px",
                    cursor: "pointer",
                    fontSize: "14px"
                  }}
                >
                  No
                </button>
              </div>
            </div>
          </div>
        )}

        <LoaderCon />
        {/* <Snackbar1
          open={this.props.snackbar.response_received}
          onClose={this.props.close_snack_bar}
          message={this.props.snackbar.message}
          anchorOrigin={{ vertical: "top", horizontal: "center" }}
        /> */}
        {/* <Snackbar1
          open={this.props.snackbar.response_received}
           onClose={this.props.close_snack_bar}
          message={this.props.snackbar.message}
        /> */}

      </div>
    );
  }
}

export default withParams(Employee);